export default __webpack_public_path__ + "static/media/bg.1cfb5ee2.svg";